import { Injectable } from '@angular/core'
import { Http, Response, URLSearchParams } from '@angular/http'
import { Angular2TokenService } from 'angular2-token'
import { Store } from "@ngrx/store"
import { AppState } from "@store/app-state"
import { Term } from "@models/term"
import { Observable } from 'rxjs'
import { ActionCableService } from "./action-cable"
import { ADD_CONTACT } from "@reducers/contacts"
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'

@Injectable()
export class TermService {

  private termsUrl: string = 'terms'

  constructor(
    private http: Angular2TokenService,
    private actionCableService: ActionCableService,
    private store: Store<AppState>,
  ) {}

  fetchTerms(): Observable<Term[]> {
    return this.http.get(this.termsUrl)
      .map((res: Response) => res.json().map((t: any) => Term.clone(t)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  create(params: any): Observable<Term> {
    return this.http.post(this.termsUrl, params)
      .map((res: Response) => Term.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  update(params: any): Observable<Term> {
    return this.http.patch(`${this.termsUrl}/${params.id}`, params)
      .map((res: Response) => Term.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/term.ts